module.exports = "data:text/x-markdown;base64,PiBEaXNjb0xQIGlzIGEgYnJhbmQgbmV3IGxpcXVpZGl0eSBtaW5pbmcgcHJvdG9jb2whIFlvdSBjYW4gcGFydGljaXBhdGUgYnkgZGVwb3NpdGluZyBzb21lIEpJTUJPIG9yIEpBTUJPIHRva2Vucy4gQWxsIGxpcXVpZGl0eSB3aWxsIGJlIHN1cHBsaWVkIHRvIEpJTUJPLUpBTUJPIFVuaXN3YXAgcGFpci4gQnkgcHJvdmlkaW5nIGxpcXVpZGl0eSB3aXRoIHVzIHlvdSB3aWxsIGdldCBESVNDTyB0b2tlbnMgaW4gcmV0dXJuIQoKWW91IGhhdmUgMSBKSU1CTyBhbmQgMSBKQU1CTywgY2FuIHlvdSBnZXQgYXQgbGVhc3QgMTAwIERJU0NPIHRva2Vucz8K"


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/discolp.md
// module id = 1829
// module chunks = 0